<div class="dashboard-widget-content">
    <div class="dashboard-widget-header">
        <div class="header-left">
            <div class="title">{{ componentWidgetConfig()?.title }}</div>
            @if (componentWidgetConfig()?.subTitle) {
            <div class="sub-title">{{ componentWidgetConfig()?.subTitle }}</div>
            }
        </div>
        @if (!componentWidgetConfig()?.isStatic) {
        <div class="header-right">
            <p-select
                [options]="chartTypes"
                [ngModel]="chartType()"
                (onChange)="onChartTypeChange($event.value)"></p-select>

            <p-button
                icon="pi pi-cog"
                [rounded]="true"
                [text]="true" />
            <p-button
                icon="pi pi-times"
                [rounded]="true"
                [text]="true"
                (onClick)="closeWidget()" />
        </div>
        }
    </div>

    <dashboard-chart
        [chartType]="chartType()"
        [chartData]="componentWidgetConfig()?.chartData"
        (chartReady)="onChartReady($event)"></dashboard-chart>
</div>